import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

import { Section } from '../../../styles/Section';

export const StyledSection = styled(Section)`
  flex-direction: column-reverse;
  display: flex;

  ${tablet768`
    flex-direction: column;
  `}

  ${desktop1024`
    flex-direction: row;
  `}
`;

StyledSection.displayName = 'StyledSection';
